/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import-helpers/order-imports */
import React, { useState, useCallback, useMemo, useContext, useLayoutEffect } from 'react';
import {
  Col,
  Row,
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from 'reactstrap';
import Skeleton from 'react-loading-skeleton';

import CustomTable from '../../components/CustomTable';
import { MONTH, SITUACAO } from '../../constants/app';
import { AppContext } from '../../contexts/app';
import { formatCnpj, numberToCurrency } from '../../utils/functions';
import useFaturas from './useFaturas';
import useFaturasDetails from './useFaturasDetails';
import './styles.css';

function Faturas() {
  const { faturas, loading } = useFaturas();
  const { faturasDetails, loading: loadingDetails, load, download, page, totalHours, totalAmount } = useFaturasDetails();
  const [showDetails, setShowDetails] = useState(false);
  const [title, setTitle] = useState('');
  const [selectedFatura, setSelectedFatura] = useState(null);
  const { setHeaderTitle } = useContext(AppContext);

  useLayoutEffect(() => {
    setHeaderTitle('Faturas');
  }, [setHeaderTitle]);

  const handleRowClick = useCallback((row) => {
    const { year, month, situacao, tipo, razaoSocial, cnpj } = row;
    load({
      year,
      month,
      situation: situacao,
      tipo,
      razaoSocial,
      cnpj,
      page: 0,
    });
    setTitle(`Detalhes - ${MONTH[row.month]} ${row.year}`);
    setSelectedFatura(row);
    setShowDetails(true);
  }, [load]);

  const handleMonthYearClick = useCallback((event, row) => {
    event.stopPropagation();
    download({
      year: row.year,
      month: row.month,
      situation: row.situacao,
      tipo: row.tipo,
      razaoSocial: row.razaoSocial,
      cnpj: row.cnpj,
    });
  }, [download]);

  const columns = useMemo(
    () => [
      {
        dataField: 'month-year',
        text: 'Mês/Ano',
        formatter: (row) => (
          <button
            type="button"
            onClick={(event) => handleMonthYearClick(event, row)}
            className="btn btn-link p-0"
          >
            {`${MONTH[row.month]} ${row.year}`}
          </button>
        ),
      },
      {
        dataField: 'tipo',
        text: 'Tipo',
        formatter: (row) => (row?.tipo ? `${row.tipo}` : '-'),
        maxWidth: '50px',
      },
      {
        dataField: 'razaoSocial',
        text: 'Empresa',
        formatter: (row) => `${row.razaoSocial}`,
        maxWidth: '170px',
        ellipsis: true,
      },
      {
        dataField: 'cnpj',
        text: 'CNPJ',
        formatter: (row) => `${formatCnpj(row.cnpj)}`,
      },
      {
        dataField: 'total',
        text: 'Total',
        formatter: (row) => (row.situacao !== 'cancelado' ? `${numberToCurrency(row.total)} (${row.qty})` : `${numberToCurrency(0)} (${row.qty})`),
      },
      {
        dataField: 'situacao',
        text: 'Situação',
        formatter: (row) => `${SITUACAO[row.situacao]}`,
      },
    ],
    [handleMonthYearClick],
  );

  const renderFooter = () => (
    <tfoot>
      <tr>
        <td style={{ borderRight: '2px solid #fff' }}>
          TOTAL
        </td>
        <td>
          {numberToCurrency(faturas?.filter?.((fatura) => fatura.situacao !== 'cancelado')?.reduce?.((acc, curr) => acc + curr.total, 0) || 0)}
          {' '}
          (
          {faturas?.filter?.((fatura) => fatura.situacao !== 'cancelado')?.reduce?.((acc, curr) => acc + curr.qty, 0) || 0}
          )
        </td>
      </tr>
    </tfoot>
  );

  const detailsRows = useMemo(() => {
    if (loadingDetails) {
      return [...(!page ? [] : faturasDetails), ...Array.from({ length: 3 })];
    }
    return faturasDetails;
  }, [faturasDetails, loadingDetails, page]);

  const companyName = selectedFatura?.razaoSocial || faturasDetails?.[0]?.razaoSocial || '-';
  const companyCnpj = selectedFatura?.cnpj || faturasDetails?.[0]?.cnpj || '';

  const unifiedTiposLabel = useMemo(() => {
    const tipos = faturasDetails
      .filter((f) => f?.tipo)
      .map((f) => f.tipo);
    const unique = Array.from(new Set(tipos)).sort((a, b) => String(a).localeCompare(String(b), 'pt-BR'));
    return unique.length ? unique.join(', ') : '-';
  }, [faturasDetails]);

  return (
    <Container fluid style={{ paddingLeft: '10px', paddingRight: '10px' }}>
      <Row>
        <Col>
          <CustomTable
            columns={columns}
            data={faturas}
            loading={loading}
            paging={false}
            onRowClick={handleRowClick}
            footer={renderFooter}
          />
        </Col>
      </Row>
      <Modal
        isOpen={showDetails}
        onClose={() => setShowDetails(false)}
        fullscreen
      >
        <ModalHeader>
          <strong>{title}</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={() => setShowDetails(false)}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          <div className="faturas-details-summary">
            <div className="faturas-details-summary-item">
              <strong>Razão Social:</strong>
              {' '}
              {companyName}
            </div>
            <div className="faturas-details-summary-item">
              <strong>CNPJ:</strong>
              {' '}
              {companyCnpj ? formatCnpj(companyCnpj) : '-'}
            </div>
            <div className="faturas-details-summary-item faturas-details-summary-tipos">
              <strong>Tipo:</strong>
              {' '}
              {unifiedTiposLabel}
            </div>
          </div>

          <Table responsive className="faturas-details-table">
            <thead>
              <tr>
                <th>EMPRESA</th>
                <th>PACIENTE</th>
                <th>DATA</th>
                <th>H-I</th>
                <th>H-T</th>
                <th>Q-H</th>
                <th>VALOR</th>
              </tr>
            </thead>
            <tbody>
              {detailsRows.map((fatura, index) => {
                if (!fatura?.tipo) {
                  return (
                    <tr key={`loading-row-${index}`} className={index % 2 ? 'is-striped' : ''}>
                      {Array.from({ length: 7 }).map((_, cellIndex) => (
                        <td key={`loading-cell-${cellIndex}`}>
                          <Skeleton height={18} />
                        </td>
                      ))}
                    </tr>
                  );
                }

                const isCanceled = fatura?.agendamento?.status === 'cancelado' || fatura?.situacao === 'cancelado';
                return (
                  <tr key={`${fatura?.paciente}-${fatura?.data}-${fatura?.horaInicio}-${fatura?.horaTermino}-${index}`} className={index % 2 ? 'is-striped' : ''}>
                    <td>{fatura?.razaoSocial || companyName}</td>
                    <td>
                      <span className="faturas-cell-ellipsis" title={fatura?.paciente || '-'}>
                        {fatura?.paciente || '-'}
                      </span>
                    </td>
                    <td className="is-center">{fatura?.data || '-'}</td>
                    <td className="is-center">{fatura?.horaInicio || '-'}</td>
                    <td className="is-center">{fatura?.horaTermino || '-'}</td>
                    <td className="is-center">{fatura?.qtdeHoras || '-'}</td>
                    <td className="is-center">{isCanceled ? numberToCurrency(0) : numberToCurrency(Number(fatura?.valor) || 0)}</td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5} className="totals-label">TOTAIS</td>
                <td className="totals-value">{totalHours}</td>
                <td className="totals-value">{numberToCurrency(totalAmount)}</td>
              </tr>
            </tfoot>
          </Table>
          {/* { hasNextPage && (
            <Row>
              <Col>
                <Button color="success" className="mb-4" block onClick={() => load({ page: page + 1 })}>
                  Carregar mais Faturas
                </Button>
              </Col>
            </Row>
          )} */}
        </ModalBody>
      </Modal>
    </Container>
  );
}

export default Faturas;
